import { render } from "./Arena_ToolsButton.vue?vue&type=template&id=65ef5f0a&scoped=true"
import script from "./Arena_ToolsButton.vue?vue&type=script&lang=js"
export * from "./Arena_ToolsButton.vue?vue&type=script&lang=js"

import "./Arena_ToolsButton.vue?vue&type=style&index=0&id=65ef5f0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ef5f0a"]])

export default __exports__